import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    FunctionField,
    SearchInput,
    Button,
    Link,
    useTranslate,
} from 'react-admin';

// Components
import EmptyList from "../components/misc/EmptyList";

// Libs
import moment from 'moment';

// Entity
const entity = "deleteUserRequests";

const deleteReasonLabel = (reason, translate) => {
    switch (String(reason)) {
        case "1":
            return translate('deleteUserRequests.reasons.another_account', { _: 'Başka bir hesabım var' });
        case "2":
            return translate('deleteUserRequests.reasons.privacy_concerns', { _: 'Gizlilik kaygılarım var' });
        case "3":
            return translate('deleteUserRequests.reasons.unused_account', { _: 'Kullanılmayan/aktif olmayan hesap' });
        case "4":
            return translate('deleteUserRequests.reasons.other_reason', { _: 'Diğer bir sebebim var' });
        default:
            return reason ? String(reason) : "—";
    }
};

const formatRequestedAt = (value) => {
    if (value == null || value === '') return '—';
    const m = typeof value === 'number' || /^\d+$/.test(String(value))
        ? moment(Number(value))
        : moment(value);
    return m.isValid() ? m.format('LLLL') : '—';
};

export const DeleteUserRequestList = (props) => {
    const translate = useTranslate();
    const filters = [
        <SearchInput key="q" source="q" alwaysOn placeholder={translate('deleteUserRequests.search_placeholder', { _: 'E-posta, isim veya telefon' })} />,
    ];

    return (
        <List
            {...props}
            empty={<EmptyList entity={entity} />}
            exporter={false}
            filters={filters}
            sort={{ field: 'createdate', order: 'DESC' }}
            perPage={50}
            title={translate('deleteUserRequests.title', { _: 'Hesap Silme Talepleri' })}
        >
            <Datagrid bulkActionButtons={false} rowClick={false}>
                <TextField source="uid" label={"ID"} />
                <FunctionField
                    source="namesurname"
                    label={translate('deleteUserRequests.name', { _: 'Ad Soyad' })}
                    render={(r) => `${r.name || ''} ${r.surname || ''}`.trim() || '—'}
                />
                <TextField source="email" label={translate('deleteUserRequests.email', { _: 'E-posta' })} />
                <TextField source="mobile" label={translate('deleteUserRequests.mobile', { _: 'Telefon' })} />
                <FunctionField
                    source="reason"
                    label={translate('deleteUserRequests.reason', { _: 'Silme Nedeni' })}
                    render={(r) => deleteReasonLabel(r.reason, translate)}
                />
                <FunctionField
                    source="createdate"
                    label={translate('deleteUserRequests.requested_at', { _: 'Talep Tarihi' })}
                    render={(r) => formatRequestedAt(r.createdate)}
                />
                <FunctionField
                    label=""
                    render={(r) =>
                        r?.uid ? (
                            <Button
                                component={Link}
                                to={`/users/${r.uid}`}
                                label={translate('deleteUserRequests.open_user', { _: 'Kullanıcıyı Aç' })}
                            />
                        ) : null
                    }
                />
            </Datagrid>
        </List>
    );
};
